/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { DeliveryInfoCardFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { DeliveryInfoCardFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import deepmerge from 'deepmerge';
import { carrierDeliveryInfoDataMock } from '../CarrierDeliveryInfo/mockdata';
import { availabilityInfoDataMock } from '../AvailabilityInfo/mockdata';

export const deliveryInfoCardDataMock: DeliveryInfoCardFragmentFragment = {
  ' $fragmentRefs': {
    AvailabilityInfoFragmentFragment: availabilityInfoDataMock,
  },
  availability: { hasExpressService: true },
  delivery: {
    ...carrierDeliveryInfoDataMock,
    deliverySize: 'L',
  },
};

export const deliveryInfoCardDataMockDefaultSize = deepmerge(deliveryInfoCardDataMock, {
  delivery: { deliverySize: 'DEFAULT' },
});

export const deliveryInfoCardDataMockNoExpressService = deepmerge(deliveryInfoCardDataMock, {
  availability: { hasExpressService: false },
});

export function getDeliveryInfoCardFragmentedData(data?: DeliveryInfoCardFragmentFragment) {
  return makeFragmentData(data || deliveryInfoCardDataMock, DeliveryInfoCardFragmentFragmentDoc);
}
